import { render, staticRenderFns } from "./NewsImageConfig.vue?vue&type=template&id=24f6e4f6"
import script from "./NewsImageConfig.vue?vue&type=script&lang=js"
export * from "./NewsImageConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports